import * as React from 'react';

export default function DefaultWidget() {
	return <h1 style={{ textAlign: 'center' }}>Invalid Widget!</h1>;
}
